export enum loaderStyle {
    normal = 1,
    rocket
}
